import React from 'react';

import useTriggersMutator from '../useTriggersMutator';

import ApiExample from './ApiExample';
import { CreateWorkflowKeyDropdown } from './ApiExample/WorkflowKeyDropdown';
import SingleTriggerSection from './SingleTriggerSection';
import TriggerSectionWrapper from './TriggerSectionWrapper';

export default function TriggersSection() {
  const { fields } = useTriggersMutator();

  if (fields.length === 0) {
    return (
      <TriggerSectionWrapper type="WAYPOINT_API">
        <ApiExample customKeyDropdown={<CreateWorkflowKeyDropdown />} />
      </TriggerSectionWrapper>
    );
  }
  return (
    <>
      {fields.map((name) => (
        <SingleTriggerSection key={name} name={name} />
      ))}
    </>
  );
}
